import { Link } from 'react-router-dom';

export function AccessDenied({ need }: { need: string }) {
  return (
    <div className="gsl-panel mx-auto max-w-xl px-6 py-8 text-center" role="alert">
      <p className="gsl-display text-2xl">Not available</p>
      <p className="mt-3 text-sm text-muted-foreground">
        This area needs the <strong>{need}</strong> role. Roles come from Oracle Fusion and refresh every 15 minutes; if you
        were just granted one, try again shortly.
      </p>
      <Link to="/" className="gsl-link mt-4 inline-block text-sm">
        Back to home
      </Link>
    </div>
  );
}
